export default __webpack_public_path__ + "static/media/Gilroy-Black.cd947f00.otf";